
import React ,{Component} from 'react'; 
import { NavLink,Outlet } from 'react-router-dom';
import Serverurl from './Apiurl';
import  logo  from './images/logo.jpg';
import AddCustomerbox from './Addcustomer';
import AddVendors from './AddVendors';
import axios from 'axios';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
export default class Layoutmenu extends Component {

   constructor(props) {
      super(props);
	  
      this.state = {groupedMenus:[],createMenuGroups:[],
	  }
   }
      
	     
 
  componentWillMount() {
 

   axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getmenubyuser&us_id='+localStorage.getItem('ISIuserid'))
      .then((res) => {
		
        if (res.data.length>0) {
			
          const grouped = this.groupByPmKey(res.data);
		     const craetegrouped = this.createrighMenu(res.data);
		 
         this.setState({ groupedMenus: grouped ,createMenuGroups:craetegrouped},()=>{});
        }
      })
      .catch((err) => console.error("Error fetching menu:", err));
  }

	  groupByPmKey(pages) {
    const grouped = {};
    pages.forEach((page) => {
		
      const group = page.pm_key || "others";
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(page);
    });
    return grouped;
  }


  createrighMenu(pages) {
    const grouped = {};
    pages.forEach((page) => {
		if (page.pm_key !== "Create") return;
      const group = page.pm_key || "others";
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(page);
    });
    return grouped;
  }
  
  renderCreateMenu() {
    const { createMenuGroups } = this.state;

    return Object.keys(createMenuGroups).map((subgroup, index) => {
      const pages = createMenuGroups[subgroup];

      return (
        <div key={index} className={`column column-${index + 1}`}>
          <div className="UIPod">
            <div className="header">
              <h2 className="title">Payments and Receipts</h2>
            </div>
            <div className="content">
              <ul className="UIMenu">
                {pages.map((page, idx) => (
                  <li key={page.pm_key} className={`item_${idx}${idx === pages.length - 1 ? " last" : ""}`}>
                    <a className="UILink" href={'/#/'+page.pm_pagename}>
                      <span>{page.pm_name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      );
    });
  }
renderMenu() {
    const { groupedMenus } = this.state;
console.log(groupedMenus)
 const noSubmenu = ["Settings"];
  const noSubmenu1 = ["Reports"];

    return Object.keys(groupedMenus).map((groupKey) => {
      const pages = groupedMenus[groupKey];

      // If group has only one item, render directly without submenu
      if (pages.length === 1 ) {
        const page = pages[0];
        return (
          <li key={page.pm_key}>
            <a href={'/#/'+page.pm_pagename}>{page.pm_name}</a>
          </li>
        );
      } 
	   if ( noSubmenu.includes(groupKey)) {
        const page = pages[0];
        return (
          <li key={page.pm_key}>
            <a href={'/#/settings'}>Settings</a>
          </li>
        );
      } 
 if ( noSubmenu1.includes(groupKey)) {
        const page = pages[0];
        return (
          <li key={page.pm_key}>
            <a href={'/#/Essentialreports'}>Reports</a>
          </li>
        );
      }
 return (
        <li key={groupKey} className="salesmenu has-submenu">
		 {(groupKey.charAt(0).toUpperCase() + groupKey.slice(1)!=="Create" ) && (
		  <>
		  
		   
          <a href="#">{groupKey.charAt(0).toUpperCase() + groupKey.slice(1)}</a>
			 
          <ul className="submenus">
            {pages.map((page) => (
              <li key={page.pm_key}>
                <a href={'/#/'+page.pm_pagename}>{page.pm_name}</a>
              </li>
            ))}
          </ul>
		  
		  </>
		 )}
        </li>
      );
    });
  }	  
render() { 
  





  return (
 
  
    <React.Fragment> 
	
	
	<Serverurl />
	

	<AddCustomerbox ref="AddCustomerbox" id={0}  />
	<AddVendors ref="AddVendors" id={0} />
	<div className="headerbg">
	<div className="main">
	<div className="logo">
	{localStorage.getItem("ISIcmpname")!=null && (
	<h2>{localStorage.getItem("ISIcmpname")} Accounting</h2>
	)}
	
	</div>
	
	<div className="hedaerlogout">
	
	<a href="/#/Logout"><ExitToAppIcon className="verticalalign"/> Logout</a>
	</div>
	<div className="clear"></div>
	</div>
	</div>

	
	<div className="headermenu">
	
	{localStorage.getItem("ISIrole")==="1" && (
	<div className="main">
	<div className="headermenus">
	<ul>
	<li><a href="/#/AdminCompany">Company</a></li>
	<li><a href="/#/AdminUser">User</a></li>
		<li><a href="/#/Adminstate">Province</a></li>
			<li><a href="/#/Addcountry">Countries</a></li>
		
	
	</ul></div></div>
	
	)}
		<div className="clear"></div>
	{(localStorage.getItem("ISIrole")==="3" || localStorage.getItem("ISIrole")==="4") && (
	
	
	
		<div className="main">
        <div className="headermenus">
          <ul>{this.renderMenu()}</ul>
        </div>
		
		<div className="main-nav-additional">
        <div className="create-button-container active-background">
          <span className="create-button-label active-label">Create</span>
          <span className="icon-add create-button-plus-button" data-element="open"></span>
        </div>

        <div className="create-button-menu-content custom-margin">
          <div className="UIRow">{this.renderCreateMenu()}</div>
          <div className="clear"></div>
        </div>
      </div>
	  
	  	<div className="clear"></div>
      </div>
	  
	)}  {( localStorage.getItem("ISIrole")==="2") && (
	  <div className="main">
	<div className="headermenus">
	<ul>
	<li className="salesmenu has-submenu"><a href="/#/Compdashboard">Dashboard</a></li>
	<li className="salesmenu has-submenu"><a href="#">Sales</a>
	<ul  className="submenus">
	<li><a href="/#/Adminsalesestimate">Estimates</a></li>
	<li><a href="/#/Adminsalesinvoice">Sales invoice</a></li>
	<li><a href="/#/Adminsalescreditnote">Sales credit notes</a></li>
	</ul>
	</li>
	<li className="contactsmenu has-submenu"><a href="#">Contacts</a>
	<ul className="submenu">
	<li><a href="/#/AdminCustomer">Customers</a></li>
	<li><a href="/#/AdminVendors">Vendors</a></li>
	<li><a href="/#/AdminUser">User</a></li>
	</ul>
	</li>
	
		<li className="contactsmenu has-submenu"><a href="#">Expenses</a>
	<ul className="submenu">
	<li><a href="/#/Adminpurchaseorder">Purchase Order</a></li>
	<li><a href="/#/Adminvendorbills">Vendor bills</a></li>
	<li><a href="/#/Adminvendorcreditnote">Vendor credit notes</a></li>
	</ul>
	</li>
	
	<li className="contactsmenu has-submenu"><a href="/#/Adminproducts">Products and Services</a>	</li>
	<li className="contactsmenu has-submenu"><a href="/#/Adminjournals">Journals</a>	</li>
	<li className="contactsmenu has-submenu"><a href="/#/settings">Settings</a>	</li>
	
	
	  <li className="salesmenu has-submenu"><a href="/#/Essentialreports">Reports</a>
	
	</li>
	</ul>
	
	</div>
	<div className="main-nav-additional">
  <div className="create-button-container active-background"><span className="create-button-label active-label">Create</span><span className="icon-add create-button-plus-button" data-element="open"></span></div>
		
		
		<div className="create-button-menu-content custom-margin" ><div className="UIRow" ><div className="column-set columns-6"><div className="column column-1 spancols-2"><div className="UIPod" ><div className="header"><h2 className="title">Buy and sell</h2></div><div className="content">
		<ul className="UIMenu" >
		<li className="item_0"><a data-tooltip="Sales Invoice"  className="UILink"   href="/#/AddSalesinvoice"><span>Sales Invoice</span></a></li>
		<li className="item_1"><a data-tooltip="Vendor Bill"  className="UILink"  href="/#/Addvendorbill"><span>Vendor Bill</span></a></li>
	
		<li className="item_3 last"><a data-tooltip="Estimate"  className="UILink"  href="/#/AddSalesestimates"><span>Estimate</span></a></li>
		</ul></div>
		</div></div>
		<div className="column column-2 spancols-3">
		<div className="UIPod" ><div className="header"><h2 className="title">Payments and receipts</h2></div><div className="content"><ul className="UIMenu" >
		<li className="item_0"><a data-tooltip="Customer Receipt" 
		className="UILink" 
		href="/#/Paymentincoming#customer-receipt"><span>Customer Receipt</span></a></li>
		<li className="item_1"><a data-tooltip="Vendor Payment" 
		className="UILink" data-tag="create_menu_purchase_payment_link"  href="/#/paymentexpenses#vendor-payment"><span>Vendor Payment</span></a></li>
		
		</ul></div>
		</div></div>
		<div className="column column-3 spancols-1"><div className="UIPod" >
		<div className="header"><h2 className="title">More...</h2></div><div className="content">
		<ul className="UIMenu" >
		<li className="item_0" onClick={()=>{this.refs.AddCustomerbox.handleClickOpen()}}><a data-tooltip="Customer"  className="UILink"  ><span>Customer</span></a></li>
		<li className="item_1" onClick={()=>{this.refs.AddVendors.handlevendorClickOpen()}}><a data-tooltip="Vendor" className="UILink" ><span>Vendor</span></a></li>
		<li className="item_2 last"><a data-tooltip="Journal"
		className="UILink" 
		href="/#/Addjournals"><span>Journal</span></a></li></ul></div>
		</div></div>
		</div><div className="clear"></div></div></div>
		
		</div>
		<div className="clear"></div>
		</div>
		)}
  </div>
	<div className="main"><div className="pageheading">
	


	{this.props.name==="" ?(
	<h2><Outlet/>  </h2>
	) : (
	<h2>{this.props.name}  </h2>
	)}
</div>
	
  </div>
  
  
    </React.Fragment> 
  /* <div className="adminpanelmenu">
       <div className="menupadding">
               <ul className="navigation"> 
                <li><a href='#'>Sales</a><ul>
                 <li><a href="/#/Adminsalesestimate">Estimates</a></li>
	<li><a href="/#/Adminsalesinvoice">Sales invoice</a></li>
	<li><a href="/#/Adminsalescreditnote">Sales credit notes</a></li>       
                    
                </ul></li>
                </ul>
     </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<div className="menupadding">
        <ul className="navigation"> 
                <li><a href='#'>Contact </a><ul>
              <li><a href="Adminabundantcartreport.aspx">Abundant Carts</a></li>
                 <li><a href="AdminOffer.aspx">Offer Management</a></li>
                <li><a href="/#/AdminCustomer">Customer</a></li>
	<li><a href="/#/AdminVendors">Vendor</a></li>     
                                       
                </ul></li>
                </ul>
     
     </div>
     
     </div> 
    
     <div className="clearboth"></div>*/
	 );
}	 
	  
}
	
  




















  
 